import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from '../common/LoadingSpinner';

const ProtectedRoute = ({ children, requiredRole = 'member' }) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  // Role validation check
  const hasRole = (role) => {
    if (!currentUser) return false;
    
    const userRole = (currentUser.role || '').toLowerCase();
    const userEmail = (currentUser.email || '').toLowerCase();
    const adminEmails = [
      'gauravkhandekar007@gmail.com',
      'beatsofredmond@gmail.com',
      'beatsofwashington@gmail.com',
      'admin@bow.org'
    ];
    const isAdmin = userRole === 'admin' || currentUser.isAdmin === true || adminEmails.includes(userEmail);

    // Admins always have access to all routes
    if (isAdmin) return true;

    // Standard user/member routes are open to all authenticated users
    if (role === 'member' || role === 'user') return true;

    return userRole === role;
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  // If not authenticated, redirect to login while preserving origin path
  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If role requirement is not satisfied, display Access Denied
  if (!hasRole(requiredRole)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
        <div className="text-center max-w-md bg-white p-8 rounded-2xl shadow-xl border border-gray-100">
          <div className="w-16 h-16 bg-red-100 text-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Access Denied</h1>
          <p className="text-gray-600 mb-6 text-sm">
            You don't have administrative privileges to view this section.
          </p>
          <button
            onClick={() => window.history.back()}
            className="w-full bg-primary-600 hover:bg-primary-700 text-white font-medium py-2.5 px-4 rounded-xl transition duration-200"
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;